export enum ReminderPromptAnswer {
  Yes = 'yes',
  No = 'no',
}

export const setReminderPromptAnswer = ({
  reminderId,
  answer,
}: {
  reminderId: string
  answer: ReminderPromptAnswer
}) => {
  const key = `reminderPromptAnswer_${reminderId}`
  sessionStorage.setItem(key, answer)
}

export const getReminderPromptAnswer = (
  reminderId: string,
): ReminderPromptAnswer | null => {
  const key = `reminderPromptAnswer_${reminderId}`
  return sessionStorage.getItem(key) as ReminderPromptAnswer | null
}
